<div class="modal-container">
    <div class="original-email">
       <lib-text
            size="xs"
            weight="medium"
            class="drawer__subject"
            [content]="email.replies[0].subject"
        >
        </lib-text>
        <div class="icon-container">
            <img
                (click)="cancel()"
                class="disapprove-icon"
                src="../../../../../../assets/icons/cancel-icon.svg"
            />
        </div>
        
    </div>
    <div class="email-container">
        <div class="email-preview">
                <app-email-preview-html [html]="email?.replies[0]?.body"></app-email-preview-html>
        </div>
        <div class="email-preview-reply">
            <div *ngFor="let reply of email?.replies | slice:1">
                <div class="email-replies">
                    <app-email-preview-html [html]="reply.body"></app-email-preview-html>
                </div>
            </div>
        </div>
    </div>
    
    <div class="buttons-actions">
        <div class="valid-button">
            <lib-ui-button
                variant="filled"
                size="m"
                [fullWidth]="true"
                (click)="confirm('valid')"
                label="Validar"
            ></lib-ui-button>
        </div>
        <div class="reject-button">
            <lib-ui-button
                variant="outline"
                size="m"
                [fullWidth]="true"
                (click)="confirm('reject')"
                label="Rechazar correo"
            ></lib-ui-button>
        </div>
        <div class="report-button">
        <lib-ui-button
                variant="outline"
                size="m"
                [fullWidth]="true"
                (click)="confirm('report')"
                label="Reportar error monto y fecha"
            ></lib-ui-button>
        </div>
    </div>
</div>